import { render, staticRenderFns } from "./ShowDepartments.vue?vue&type=template&id=1424b03f&"
import script from "./ShowDepartments.vue?vue&type=script&lang=js&"
export * from "./ShowDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports